/**
 * My-Collection 페이지 Config
 *
 * 현재 모든 팀이 동일한 값을 사용합니다.
 */

import type { TeamSlug } from '@/app/(football)/[team]/_context/types';
import type { MyCollectionPageConfig } from '@/app/(football)/[team]/my-collection/_context/types';

import { bluewingsConfig } from './bluewings';
import { dhcfcConfig } from './dhcfc';
import { fcanyangConfig } from './fcanyang';
import { fcseoulConfig } from './fcseoul';
import { jbfcConfig } from './jbfc';
import { steelersConfig } from './steelers';
import { uhdfcConfig } from './uhdfc';

export const myCollectionConfig: Record<TeamSlug, MyCollectionPageConfig> = {
  fcseoul: fcseoulConfig,
  bluewings: bluewingsConfig,
  steelers: steelersConfig,
  fcanyang: fcanyangConfig,
  uhdfc: uhdfcConfig,
  dhcfc: dhcfcConfig,
  jbfc: jbfcConfig,
};
